<template>
    <div
        v-if="icon"
        :class="[value.state]"
    >
        <FontAwesomeIcon :icon="`fa-solid fa-${icon}`" />
    </div>
</template>

<script lang="ts" setup>
import { CheckResultState, type CheckResult } from '@/api/interfaces/identity-verification-report.api';
import { computed } from 'vue';

const iconName = {
    [CheckResultState.CautiousFailed]: 'exclamation-triangle',
    [CheckResultState.Failed]: 'circle-xmark',
    [CheckResultState.Unverified]: 'exclamation-triangle',
    [CheckResultState.NotApplicable]: '',
    [CheckResultState.Passed]: 'check-circle',
    [CheckResultState.NotFound]: 'question-mark-circle',
} as const;

const props = defineProps<{ value: CheckResult }>();
const icon = computed(() => iconName[props.value.state] ?? 'question-mark-circle');
</script>

<style scoped>
.failed {
    @apply text-semantic-destructive-primary-default;
}

.passed {
    @apply text-ds-green-500;
}

.needs_review {
    @apply text-content-primary;
}

.cautious_failed {
    @apply text-ds-yellow-500;
}
</style>
